import { useEffect, useState, useCallback } from 'react'
import * as Sentry from '@sentry/react'
import { i18n } from '@fs/zion-locale'
import { SUPPRESSED_PLAYER_ERRORS } from '../../../../config/video'

function isSuppressedError(message, error) {
  const errorString = `${message ?? ''} ${error?.message ?? ''}`
  return SUPPRESSED_PLAYER_ERRORS.some((suppressed) => errorString.includes(suppressed))
}

export default function useError(videoProvider) {
  const [isError, setIsError] = useState()

  const onError = useCallback(
    ({ error, message }) => {
      const errorMessage = message || 'Something went wrong with the VideoProvider'
      const suppressed = isSuppressedError(message, error)

      // this console.error is for logging in Sentry, it doesn't handle objects very well
      console.error(
        'message:',
        errorMessage,
        '\nerror:',
        error,
        '\nvideo data:',
        JSON.stringify({ locale: i18n.language, videoProvider })
      )
      const customError = new Error(errorMessage, { error })
      Sentry.captureException(customError)

      if (!suppressed) {
        setIsError(true)
      }
    },
    [videoProvider]
  )

  useEffect(() => {
    let isCurrent = true
    isCurrent && setIsError(false)

    return () => {
      isCurrent = false
    }
  }, [videoProvider])

  return [isError, onError]
}
